import { Button, Modal } from "antd";

type ResponseModalProps = {
  open: boolean;
  title: string;
  onOk: () => void;
  onCancel: () => void;
  username?: string;
  password?: string;
};

const DeviceCreatedModal = (props: ResponseModalProps) => (
  <Modal
    open={props.open}
    title={props.title}
    onOk={props.onOk}
    onCancel={props.onCancel}
    footer={[
      <Button key="submit" type="primary" onClick={props.onOk}>
        Ok
      </Button>
    ]}
  >
    <p>
      Username: <strong>{props.username}</strong>
    </p>
    <p>
      Password: <strong>{props.password}</strong>
    </p>
  </Modal>
);

export default DeviceCreatedModal;